import React from 'react';
import PageVisitHeatmap from '../../components/PageVisitHeatmap/PageVisitHeatmap';
import './AnalyticsReports.scss';

const AnalyticsReports = () => {
  return (
    <div className="analytics-reports">
      <div className="reports-header">
        <h2>Analytics Reports</h2>
        <p>Generate and view detailed reports from your analytics data.</p>
      </div>
      
      <div className="reports-content">
        <PageVisitHeatmap />
      </div>
    </div>
  );
};

export default AnalyticsReports;

